module.exports = __webpack_public_path__ + "img/car_rest.5c1a080a.png";